<template>
  <div class="qb-wrapper">
    <button
        class="qb-trigger-btn"
        :style="bgStyle"
        aria-label="Quick Bet"
    >
    </button>

<!--    <transition name="fade">-->
<!--      <div-->
<!--          v-if="isOpen"-->
<!--          class="qb-modal-overlay"-->
<!--          role="dialog"-->
<!--          aria-modal="true"-->
<!--      >-->
<!--        <div class="qb-modal-backdrop" @click="closeModal"></div>-->

<!--        <div class="qb-modal-content">-->
<!--          <h3 class="qb-modal-title">-->
<!--            {{ t('selectNumberOfEvents') }}-->
<!--          </h3>-->
<!--          <p class="qb-modal-subtitle">-->
<!--            {{ t('insertNumberOfEvents') }}-->
<!--          </p>-->

<!--&lt;!&ndash;          <IllinoisCounter&ndash;&gt;-->
<!--&lt;!&ndash;              v-model="requestedCount"&ndash;&gt;-->
<!--&lt;!&ndash;              :min="1"&ndash;&gt;-->
<!--&lt;!&ndash;              class="qb-counter"&ndash;&gt;-->
<!--&lt;!&ndash;              ref="numInput"&ndash;&gt;-->
<!--&lt;!&ndash;          />&ndash;&gt;-->

<!--          <div class="qb-modal-actions">-->
<!--            <button class="qb-btn-cancel" @click="closeModal">-->
<!--              {{ t('cancel') }}-->
<!--            </button>-->
<!--            <button class="qb-btn-confirm" @click="confirm">-->
<!--              {{ t('confirm') }}-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </transition>-->
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: 'QuickBetItem',
  props: {
    backgroundUrl: {
      type: String,
      default: ""
    },
    sportId: {
      type: String,
      default: ""
    },
    categoryId: {
      type: String,
      default: ""
    },
    tournamentId: {
      type: String,
      default: ""
    }
  },
  components: {},
  data: () => ({}),
  methods:{

  },
  computed: {
    ...mapGetters({
      // 'getGameConsole': 'settings/getGameConsole'
    }),
    bgStyle() {
      return this.backgroundUrl
          ? {
            backgroundImage: `url(${this.backgroundUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }
          : {};
    }
  },
};
import Vue from 'vue';
// import { Component, Prop } from 'vue-property-decorator';
// import store from '@/store/index';
// import { addOddToCartV3FromSport } from '@/composables/useOdds';
// import IllinoisCounter from './Counter.vue';

// @Component({
//   components: { IllinoisCounter }
// })
// export default class QuickBetItem extends Vue {
//   // @Prop({ type: String, required: true }) readonly sportId!: string;
//   // @Prop({ type: String, required: true }) readonly categoryId!: string;
//   // @Prop({ type: String, required: true }) readonly tournamentId!: string;
//   // @Prop({ type: String, required: false, default: '' })
//   readonly backgroundUrl!: string;
//
//   isOpen: boolean = false;
//   requestedCount: number = 1;
//

//
//   openModal() {
//     this.isOpen = true;
//     this.$nextTick(() => {
//       const el = this.$refs.numInput as any;
//       // Focus sull'input se il componente figlio lo supporta nativamente
//       if (el && typeof el.focus === 'function') el.focus();
//     });
//     this.ensureTournamentEvents();
//   }
//
//   closeModal() {
//     this.isOpen = false;
//   }
//
//   async ensureTournamentEvents() {
//     try {
//       await store.dispatch('IllinoisSport/fetchEventsByTournament', {
//         sportId: this.sportId,
//         categoryId: this.categoryId,
//         tournamentId: this.tournamentId
//       });
//     } catch (e) {
//       // silenzioso: lo store evita doppie fetch
//     }
//   }
//
//   async confirm() {
//     this.$store.dispatch('cart/resetCart');
//     const n = Math.max(1, Number(this.requestedCount || 1));
//     const tournamentKey = String(this.tournamentId);
//     const groups = (store.getters['IllinoisSport/getAllEventsByTournament'] ||
//         store.state.IllinoisSport.eventsByTournament) as any;
//     const grouped =
//         groups && groups[tournamentKey] ? groups[tournamentKey] : [];
//     const allEvents = Array.isArray(grouped)
//         ? grouped.flatMap((g: any) => (Array.isArray(g.events) ? g.events : []))
//         : [];
//
//     if (!allEvents.length) {
//       this.closeModal();
//       return;
//     }
//
//     const pickedEvents = this.pickRandom(allEvents, n);
//
//     for (const ev of pickedEvents) {
//       const oddsList = Array.isArray(ev?.odds) ? ev.odds : [];
//       if (!oddsList.length) continue;
//       const market = oddsList[Math.floor(Math.random() * oddsList.length)];
//       const outcomes = Array.isArray(market?.outcome) ? market.outcome : [];
//       if (!outcomes.length) continue;
//       const outcome = outcomes[Math.floor(Math.random() * outcomes.length)];
//
//       try {
//         await addOddToCartV3FromSport({
//           eventId: ev.id,
//           outcomeUniqueId: outcome.unique_id,
//           sportId: this.sportId,
//           sportName: String(ev?.sportName || ''),
//           categoryId: this.categoryId,
//           categoryName: String(ev?.categoryName || ''),
//           tournamentId: this.tournamentId,
//           tournamentName: String(ev?.tournamentName || ''),
//           marketId: String(market?.unique_id || market?.id)
//         });
//       } catch (err) {
//         // continua sugli altri eventi
//       }
//     }
//
//     this.closeModal();
//     this.$store.dispatch('cart/setIsCartOpen', true);
//   }
//
//   pickRandom<T>(arr: T[], count: number): T[] {
//     const max = Math.min(count, arr.length);
//     const copy = arr.slice();
//     for (let i = copy.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [copy[i], copy[j]] = [copy[j], copy[i]];
//     }
//     return copy.slice(0, max);
//   }
//
//   t(key: string) {
//     return this.$t(key);
//   }
// }
</script>

<style scoped>
/* Variabili tema (sostituiscile coi tuoi colori esatti se serve) */
.qb-wrapper {
  --illinois-primary: #0056b3; /* Modifica con il primary del tuo brand */
  --illinois-darker: #1a202c;
  --illinois-border: #e2e8f0;

  position: relative;
  height: 100%;
}

/* Pulsante copertina */
.qb-trigger-btn {
  width: 100%;
  height: 100%;
  border-radius: 6px; /* Equivalente al rounded-lg genitore o rounded */
  overflow: hidden;
  outline: none;
  border: none;
  background-color: transparent;
  cursor: pointer;
}

/* Overlay Modal */
.qb-modal-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qb-modal-backdrop {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #000;
  opacity: 0.5;
}

.qb-modal-content {
  position: relative;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04);
  width: 91.666667%; /* Equivalente w-11/12 */
  max-width: 24rem;  /* Equivalente max-w-sm */
  padding: 1rem;
}

/* Testi Modal */
.qb-modal-title {
  font-size: var(--font-size-7xl);
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: var(--illinois-darker);
}

.qb-modal-subtitle {
  font-size: var(--font-size-2xl);
  margin: 0 0 0.75rem 0;
  color: var(--illinois-darker);
}

/* Contatore */
.qb-counter {
  color: var(--illinois-darker);
  border: 1px solid var(--illinois-border);
  border-radius: 4px;
  margin-bottom: 1rem;
}

/* Azioni Modal */
.qb-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem; /* space-x-2 */
}

.qb-btn-cancel,
.qb-btn-confirm {
  padding: 0.5rem 0.75rem;
  font-size: var(--font-size-4xl);
  border-radius: 4px;
  cursor: pointer;
  outline: none;
  transition: opacity 0.2s;
}

.qb-btn-cancel:hover,
.qb-btn-confirm:hover {
  opacity: 0.85;
}

.qb-btn-cancel {
  background-color: transparent;
  border: 1px solid var(--illinois-border);
  color: var(--illinois-darker);
}

.qb-btn-confirm {
  background-color: var(--illinois-primary);
  border: 1px solid var(--illinois-primary);
  color: #fff;
}

/* Transizioni */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 150ms ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>